var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "projects-card transition delay-75 duration-150 overflow-hidden",
      class: _vm.isUrgent && !_vm.isAccepted && `project-card-red`,
    },
    [
      _c("div", { staticClass: "flex flex-row justify-between items-center" }, [
        _c(
          "div",
          [
            _vm.isOffered && !_vm.noAssignee
              ? _c("Badge", {
                  staticClass: "text-badge capitalize",
                  attrs: {
                    color: _vm.BadgeColor.OFFERED,
                    value: "Offered",
                    styleClasses: "py-0.5 px-2",
                  },
                })
              : _vm._e(),
            _vm.isOffered && _vm.noAssignee
              ? _c("Badge", {
                  attrs: {
                    color: _vm.BadgeColor.OPEN,
                    value: "Open",
                    styleClasses:
                      "text-badge capitalize customBadgeWidth py-0.5 px-2",
                    showIcon: true,
                  },
                })
              : _vm._e(),
            _vm.isDeclined
              ? _c("Badge", {
                  attrs: {
                    color: _vm.BadgeColor.WARNING,
                    value: "Declined",
                    styleClasses:
                      "text-storm-gray bg-gray-tabs capitalize customBadgeWidth py-0.5 px-2",
                  },
                })
              : _vm._e(),
            _vm.isAccepted
              ? _c("Badge", {
                  staticClass: "capitalize text-badge",
                  attrs: {
                    color: _vm.BadgeColor.ACTIVE,
                    value: "Accepted",
                    styleClasses: "py-0.5 px-2",
                  },
                })
              : _vm._e(),
            _vm.isDrafted
              ? _c("Badge", {
                  staticClass: "capitalize",
                  attrs: {
                    color: _vm.BadgeColor.DRAFT,
                    value: "Draft",
                    styleClasses:
                      "text-storm-gray bg-gray-tabs capitalize customBadgeWidth py-0.5 px-2",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        !_vm.activity.completed
          ? _c(
              "div",
              { staticClass: "flex flex-row items-center" },
              [
                _c("DeleteTaskAction", {
                  attrs: {
                    currentUserRole: _vm.currentUser.role,
                    companyId: _vm.companyId,
                    projectActivity: _vm.activity,
                  },
                  on: { visitDeleted: _vm.visitUpdated },
                }),
                _c("EditTaskAction", {
                  attrs: {
                    isIcon: true,
                    projectActivity: _vm.activity,
                    companyId: _vm.companyId,
                    currentUserId: _vm.currentUser.id,
                    currentUserRole: _vm.currentUser.role,
                  },
                }),
              ],
              1
            )
          : _c("div"),
      ]),
      _c(
        "div",
        { staticClass: "project-name focus:!outline-none" },
        [
          _vm.isTruncated
            ? _c(
                "Tooltip",
                {
                  staticClass: "flex items-center",
                  attrs: {
                    variant: _vm.TooltipVariants.LIGHT,
                    title: _vm.activity.title,
                    tooltipClasses: "w-56",
                    placement: "right",
                  },
                },
                [
                  _c(
                    "p",
                    {
                      ref: "titleElement",
                      staticClass:
                        "block hover:text-primary minHeight cursor-pointer focus!:outline-none text-lg font-medium truncate-title text-left",
                      on: { click: _vm.projectDetails },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.activity.project?.client_name) + " "
                      ),
                    ]
                  ),
                ]
              )
            : _c(
                "p",
                {
                  ref: "titleElement",
                  staticClass:
                    "block hover:text-primary cursor-pointer focus!:outline-none text-lg font-medium truncate-title text-left",
                  on: { click: _vm.projectDetails },
                },
                [_vm._v(" " + _vm._s(_vm.activity.project?.client_name) + " ")]
              ),
        ],
        1
      ),
      _c("div", { staticClass: "visit-info flex items-center gap-1" }, [
        _vm.activity.virtual
          ? _c(
              "span",
              {
                staticClass:
                  "inline-flex items-center rounded text-xs font-medium",
              },
              [_vm._v("Virtual ")]
            )
          : _c(
              "span",
              {
                staticClass:
                  "inline-flex items-center rounded text-xs font-medium bg-blue-100 text-blue-800",
              },
              [_vm._v("In-Person ")]
            ),
        _vm.visitType !== "n/a"
          ? _c("span", { staticClass: "text-gray-500" }, [
              _vm._v("- " + _vm._s(_vm.visitType)),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "dates" }, [
        _c("div", { staticClass: "flex flex-row" }, [
          _c("img", {
            staticClass: "mr-1.5",
            attrs: {
              src: require("@/assets/calendar-icon.svg"),
              alt: "location",
            },
          }),
          _c("div", { staticClass: "visit-info" }, [
            _vm._v(_vm._s(_vm.startDate)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "dates" }, [
        _c(
          "div",
          { staticClass: "flex flex-row" },
          [
            _c("ClockIcon"),
            _c("div", { staticClass: "ml-1.5 visit-info" }, [
              _vm._v(_vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime)),
            ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "location" }, [
        _c(
          "div",
          { staticClass: "flex flex-row gap-1" },
          [
            _c("CalendarIcon", {
              staticClass: "w-4 h-4 mr-1.5 locationMin minWidthFitContent",
            }),
            _vm.activity.virtual && _vm.activity.virtual_meeting_link
              ? _c(
                  "a",
                  {
                    staticClass:
                      "text-blue text-sm font-400 hover:underline inline-flex items-center gap-1",
                    attrs: {
                      href: _vm.activity.virtual_meeting_link,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "2",
                            y: "7",
                            width: "20",
                            height: "15",
                            rx: "2",
                            ry: "2",
                          },
                        }),
                        _c("polyline", { attrs: { points: "22,7 12,13 2,7" } }),
                      ]
                    ),
                    _vm._v(" Join Virtual Meeting "),
                  ]
                )
              : _vm.location
              ? _c(
                  "a",
                  {
                    staticClass: "text-blue text-sm font-400 hover:underline",
                    attrs: {
                      href: _vm.googleMapsLink,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.location) + " ")]
                )
              : _c("p", { staticClass: "text-blue text-sm font-400" }, [
                  _vm._v("n/a"),
                ]),
          ],
          1
        ),
      ]),
      _vm.activity.virtual && _vm.activity.fallback_num
        ? _c("div", { staticClass: "location" }, [
            _c("div", { staticClass: "flex flex-row gap-1" }, [
              _c(
                "svg",
                {
                  staticClass:
                    "w-4 h-4 mr-1.5 minWidthFitContent text-gray-500",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
                    },
                  }),
                ]
              ),
              _c("p", { staticClass: "text-gray-600 text-sm font-400" }, [
                _vm._v(_vm._s(_vm.activity.fallback_num)),
              ]),
            ]),
          ])
        : _vm._e(),
      !_vm.isDeclined && !_vm.noAssignee
        ? _c(
            "div",
            {
              staticClass:
                "flex gap-1 w-full items-center mt-3 minHeightAssignee",
            },
            [
              _c("span", { staticClass: "team-teams" }, [_vm._v("Assignee:")]),
              this.activity.contractor_id && this.activity.contractor?.user
                ? _c(
                    "RouterLink",
                    {
                      attrs: {
                        to: `/company_database/contractors/${this.activity?.contractor?.id}/about`,
                      },
                    },
                    [
                      _c("div", { staticClass: "flex flex-row gap-1" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "manager-chips flex flex-row items-center text-left",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "rounded-full flex items-center text-xs flex-shrink-0 justify-center text-white manager-image hover:text-white hover:border-primary-500",
                                style: _vm.bgStyle,
                              },
                              [_vm._v(" " + _vm._s(_vm.initial) + " ")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  this.activity.contractor?.user.given_name
                                ) +
                                " " +
                                _vm._s(
                                  this.activity.contractor?.user.family_name
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _c("div", { staticClass: "manager" }, [_vm._v("n/a")]),
            ],
            1
          )
        : _vm._e(),
      _vm.isDeclined
        ? _c(
            "div",
            {
              staticClass:
                "bg-red-50 border border-red-200 rounded-lg p-3 flex items-start gap-2 mb-4 mt-4",
            },
            [
              _c(
                "svg",
                {
                  staticClass:
                    "lucide lucide-circle-alert w-4 h-4 text-red-600 mt-0.5 flex-shrink-0",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                  },
                },
                [
                  _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                  _c("line", {
                    attrs: { x1: "12", x2: "12", y1: "8", y2: "12" },
                  }),
                  _c("line", {
                    attrs: { x1: "12", x2: "12.01", y1: "16", y2: "16" },
                  }),
                ]
              ),
              _c("div", [
                _c("p", { staticClass: "text-red-600 text-sm font-medium" }, [
                  _vm._v(_vm._s(_vm.alertType)),
                ]),
                _c("p", { staticClass: "text-gray-600 text-xs mt-1" }, [
                  _vm._v(_vm._s(_vm.alertMessage)),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      (_vm.isDeclined || _vm.noAssignee) && _vm.isCurrentUserCreator
        ? _c("div", [
            _c(
              "p",
              {
                staticClass:
                  "text-sm font-normal leading-normal text-brown text-400 mb-1",
              },
              [_vm._v(" Suggested assignees: ")]
            ),
            _vm.isDeclined &&
            _vm.filteredBookmarkedContractors &&
            _vm.filteredBookmarkedContractors.length > 0
              ? _c("div", { staticClass: "mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-2 mb-3" },
                    _vm._l(
                      _vm.filteredBookmarkedContractors,
                      function (contractor) {
                        return _c(
                          "button",
                          {
                            key: contractor.id,
                            staticClass:
                              "inline-flex items-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] border bg-background hover:text-accent-foreground h-8 rounded-md gap-1.5 px-3 text-gray-700 border-gray-200 hover:bg-gray-50 justify-start",
                            on: {
                              click: function ($event) {
                                return _vm.handleContractorClick(
                                  contractor.user
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "lucide lucide-bookmark w-4 h-4 mr-2",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "24",
                                  height: "24",
                                  viewBox: "0 0 24 24",
                                  fill: "#eab308",
                                  stroke: "#eab308",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              " Offer to " +
                                _vm._s(contractor.user.given_name) +
                                " " +
                                _vm._s(contractor.user.family_name) +
                                " "
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                  _c(
                    "button",
                    {
                      staticClass:
                        "smartMatchConfigButton inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] border hover:text-accent-foreground h-8 rounded-md gap-1.5 px-3 text-blue-600 border-blue-200 hover:bg-blue-50 bg-blue-50/50",
                      on: { click: _vm.openSmartMatchModal },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "lucide lucide-settings w-4 h-4 mr-2",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
                            },
                          }),
                          _c("circle", {
                            attrs: { cx: "12", cy: "12", r: "3" },
                          }),
                        ]
                      ),
                      _vm._v(" Smart Match Config "),
                    ]
                  ),
                ])
              : _vm.isDeclined &&
                _vm.filteredDeclinedMatches &&
                _vm.filteredDeclinedMatches.length > 0
              ? _c("div", { staticClass: "mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-2 mb-3" },
                    _vm._l(_vm.filteredDeclinedMatches, function (match) {
                      return _c(
                        "button",
                        {
                          key: match.id,
                          staticClass:
                            "inline-flex items-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] border bg-background hover:text-accent-foreground h-8 rounded-md gap-1.5 px-3 text-gray-700 border-gray-200 hover:bg-gray-50 justify-start",
                          on: {
                            click: function ($event) {
                              return _vm.handleContractorClick(match.user)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 gap-1 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] transition-[color,box-shadow] overflow-hidden border-transparent mr-2",
                              class: _vm.getMatchBadgeClass(
                                match.match_percentage
                              ),
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(Math.round(match.match_percentage)) +
                                  "% "
                              ),
                            ]
                          ),
                          _c("span", [
                            _vm._v(
                              "Offer to " +
                                _vm._s(match.user.given_name) +
                                " " +
                                _vm._s(match.user.family_name)
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "button",
                    {
                      staticClass:
                        "smartMatchConfigButton inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] border hover:text-accent-foreground h-8 rounded-md gap-1.5 px-3 text-blue-600 border-blue-200 hover:bg-blue-50 bg-blue-50/50",
                      on: { click: _vm.openSmartMatchModal },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "lucide lucide-settings w-4 h-4 mr-2",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
                            },
                          }),
                          _c("circle", {
                            attrs: { cx: "12", cy: "12", r: "3" },
                          }),
                        ]
                      ),
                      _vm._v(" Smart Match Config "),
                    ]
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.showSmartMatchModal
        ? _c("SmartMatchConfigModal", {
            attrs: {
              companyId: _vm.companyId,
              currentUserId: _vm.currentUser.id,
              currentUser: _vm.currentUser,
            },
            on: { close: _vm.closeSmartMatchModal },
          })
        : _vm._e(),
      !_vm.isAccepted && !_vm.isDeclined
        ? _c("div", { staticClass: "action-section mt-2" }, [
            _c(
              "div",
              {
                staticClass:
                  "relative flex flex-col p-1 min-h-11 justify-center h-auto items-center resourceActionHeight",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-row gap-1 items-center justify-center",
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass:
                          "lucide lucide-circle-alert w-4 h-4 text-red-600 mt-0.5 flex-shrink-0",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: { cx: "12", cy: "12", r: "10" },
                        }),
                        _c("line", {
                          attrs: { x1: "12", x2: "12", y1: "8", y2: "12" },
                        }),
                        _c("line", {
                          attrs: { x1: "12", x2: "12.01", y1: "16", y2: "16" },
                        }),
                      ]
                    ),
                    _c("div", { staticClass: "error-title text-center" }, [
                      _vm._v(_vm._s(_vm.alertType)),
                    ]),
                  ]
                ),
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative flex flex-col p-1 min-h-11 justify-center h-auto items-center",
                    },
                    [
                      _c("div", { staticClass: "internal-message" }, [
                        _vm._v(" " + _vm._s(_vm.alertMessage) + " "),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }